/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { Select } from '@leverege/ui-redux';
import { Flex, Checkbox, Button, Text, Toast, Dialogs } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import ResetTemporaryUserDialog from "./components/ResetTemporaryUserDialog.js";
import Defaults from "./components/Defaults.js";
const {
  t
} = I18N.ns('temporaryUserManagement.Columns');
/**
 * @param {} targeted
 * @param {} targetedCount
 * @param {array} users
 * @param {function} onCheck
 * @param {function} onCheckAll
 * @param {function} onEdit
 */
function getColumns({
  targeted,
  targetedCount,
  users,
  onCheck,
  onCheckAll,
  context
}) {
  // This should be coming from a profile model.
  return [{
    id: 'targeted',
    maxWidth: 50,
    resizable: false,
    sortable: false,
    accessor: d => Select.isSelected(targeted, d.username),
    Header: () => {
      const selected = targetedCount !== 0 && targetedCount === users.length;
      return /*#__PURE__*/React.createElement(Flex, {
        variant: "rowS",
        align: "center"
      }, /*#__PURE__*/React.createElement(Checkbox, {
        variant: "small",
        value: selected,
        onChange: onCheckAll
      }));
    },
    Cell: ({
      original,
      value
    }) => {
      return /*#__PURE__*/React.createElement(Flex, {
        align: "center"
      }, /*#__PURE__*/React.createElement(Checkbox, {
        variant: "small",
        eventData: original,
        value: value,
        onChange: onCheck
      }));
    }
  }, {
    Header: () => t('username'),
    sortable: false,
    id: 'username',
    accessor: 'id'
  }, {
    Header: () => t('copyLinkHeader'),
    minWidth: 168,
    sortable: false,
    id: 'copyLink',
    accessor: d => d,
    Cell: ({
      original,
      value
    }) => {
      let resolvedUiUrl = context.uiUrl;
      if (typeof context.uiUrl === 'function') {
        resolvedUiUrl = context.uiUrl({
          user: original,
          methods: ['link']
        });
      }
      const linkValue = t('copyLink', {
        temporaryUser: original,
        uiUrl: resolvedUiUrl
      });
      const onCopy = ({
        data
      }) => {
        navigator.clipboard.writeText(data);
        Toast.success(t('copyLinkSuccess'));
      };
      return /*#__PURE__*/React.createElement(Flex, {
        align: "center"
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "copyToClipboard",
        eventData: linkValue,
        onClick: onCopy
      }, t('copyLinkButton')));
    }
  }, {
    Header: () => t('resetAccessCodeHeader'),
    minWidth: 208,
    sortable: false,
    id: 'resetAccessCode',
    accessor: d => d,
    Cell: ({
      original,
      value
    }) => {
      const onReset = () => {
        Dialogs.show({
          component: ResetTemporaryUserDialog,
          props: {
            ...context,
            user: original
          }
        });
      };
      return /*#__PURE__*/React.createElement(Flex, {
        align: "center"
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "secondary",
        onClick: onReset
      }, t('resetAccessCodeButton')));
    }
  }, {
    id: 'status',
    Header: () => t('status'),
    sortable: false,
    accessor: d => {
      const now = Date.now();
      const validAfter = new Date(d.validAfter).getTime();
      const expiresAt = new Date(d.expiresAt).getTime();
      if (d.revokedAt != null) {
        return t('revoked');
      }
      if (expiresAt < now) {
        return t('expired');
      }
      if (validAfter > now) {
        return t('pending');
      }
      return t('active');
    }
  }, {
    id: 'validAfter',
    Header: () => t('validAfter'),
    accessor: d => new Date(d.validAfter).toLocaleString().replace(',', '')
  }, {
    id: 'expiresAt',
    Header: () => t('expiresAt'),
    accessor: d => new Date(d.expiresAt).toLocaleString().replace(',', '')
  }, {
    Header: () => t('description'),
    sortable: false,
    accessor: 'description'
  }, {
    id: 'createdBy',
    Header: t('createdBy'),
    sortable: false,
    accessor: d => d.createdByName || d.createdByUsername
  }, {
    Header: () => t('roles'),
    sortable: false,
    id: 'roles',
    accessor: item => {
      return item.roles?.map(role => /*#__PURE__*/React.createElement(Text, {
        key: role.id
      }, role.displayName || role.name));
    }
  }];
}
export { getColumns };
export default {
  getColumns
};